import { createGlobalStyle, CarvanaTheme } from '@carvana/theme';
import { css } from 'styled-components';

// note Brandon Text fonts seem to be injected by Carvana Template
// no need to add font face

// TODO: Refactor out
const globalStyles = createGlobalStyle(
  <any>'development',
  css`
    body {
      font-family: 'Brandon Text';
      margin: 0;
      background-color: ${CarvanaTheme.carvana.body};
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    p {
      margin-bottom: 0;
    }

    label {
      margin-bottom: 0;
    }

    a,
    a:hover {
      text-decoration: none;
    }

    ul {
      margin-bottom: 0;
      margin-block-start: 0;
      margin-block-end: 0;
      padding-inline-start: 0;
    }

    .vm-hero-map .mapContainer {
      height: 50vw;
      width: 100%;
      top: 0;
      min-height: initial;
      max-height: initial;
      @media (min-width: ${CarvanaTheme.breakpoints.values.sm}px) {
        height: 50vw;
      }
      @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
        height: 100vw;
        max-height: 840px;
        min-height: 840px;
      }
    }

    .mapContainer {
      height: 956px;
      width: 100%;
      top: 0;
      position: absolute;
      max-height: 683px;
      min-height: 683px;

      @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
        max-height: 956px;
        min-height: 956px;
      }
    }

    // override the map marker label styles
    .mapContainer
      > div
      > div.gm-style
      > div
      > div
      > div
      > div
      > div
      > div
      > div {
      color: #000000;
      text-shadow:
        -1px -1px 0 #eeeeee,
        1px -1px 0 #eeeeee,
        -1px 1px 0 #ffffff,
        1px 1px 0 #eeeeee;
    }

    .custom-clustericon {
      width: 52;
      height: 52;
    }
    @media (max-width: 768px) {
      .alignLeft {
        align-self: flex-start;
      }
      .alignRight {
        margin-left: 160px;
        align-self: flex-end;
      }
    }

    .float-container {
      padding: 0 8px;
      position: relative;
    }
    .float-container input {
      border: none;
      font-size: 16px;
      outline: 0;
    }
    label {
      color: ${CarvanaTheme.carvana.gray.dark};
      font-size: 14px;
      line-height: 56px;
      font-weight: 700;
      position: absolute;
      text-transform: uppercase;
      font-family: 'Brandon Text';
      transform-origin: top left;
      transform: translate(1em, 0em) scale(1);
      transition: all 0.1s ease-in-out;
      width: 105%;
    }
    .float-container.active label {
      transform: translate(1.1em, -0.25em) scale(0.75);
      color: ${CarvanaTheme.carvana.blue.primary};
    }
    .float-container.error label {
      transform: translate(1.1em, -0.25em) scale(0.75);
      color: ${CarvanaTheme.carvana.red.primary};
    }
    .error-marker {
      float: right;
      display: block;
      color: white;
      background: ${CarvanaTheme.carvana.red.primary};
      font-size: 18px;
      border-radius: 55%;
      height: 18px;
      text-align: center;
      width: 18px;
      margin-top: 19px;
      font-weight: bolder;
      line-height: 1;
    }
    .zip-text {
      float: left;
    }
  `
);

export default globalStyles;
